<div class="container" [attr.data-testid]="'confirm-dialog-container'">
  <form class="from" [attr.data-testid]="'confirm-dialog-form'">
    @if (data.title) {
      <h2 [attr.data-testid]="'confirm-dialog-title'">
        {{ data.title }}
      </h2>
    }

    @if (data.content) {
      <p [attr.data-testid]="'confirm-dialog-content'">
        {{ data.content }}
      </p>
    }

    @if (data.htmlContent) {
      <div
        [innerHtml]="data.htmlContent"
        [attr.data-testid]="'confirm-dialog-html-content'"
      ></div>
    }
    <div class="buttons" [attr.data-testid]="'confirm-dialog-buttons'">
      <button
        mat-button
        [mat-dialog-close]="false"
        tabindex="2"
        [attr.data-testid]="'confirm-dialog-cancel-button'"
        >
        @if (data?.cancel) {
          {{
          data.cancel
          }}
        } @else {
          <ng-container i18n>取消</ng-container>
        }
      </button>
      <button
        mat-button
        color="primary"
        [mat-dialog-close]="true"
        cdkFocusInitial
        [attr.data-testid]="'confirm-dialog-confirm-button'"
        >
        @if (data?.ok) {
          {{
          data.ok
          }}
        } @else {
          <ng-container i18n>確定</ng-container>
        }
      </button>
    </div>
  </form>
</div>
